import React, { useState } from 'react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { joinKeys } from 'helpers/translations.helper'
import { IExternalCourseParticipant } from 'models/externalCourseParticipant.model'
import { useAccess } from 'contexts/AccessContext'
import { DropdownLoader } from 'components/ui/DropdownLoader'
import { DropdownButton, styles } from 'components/ui/DropdownButton'
import { prefixTranslation } from './common'

export interface OptionsEvents {
  onDelete(): void
  onDeleteCertificate(): void
  onDownloadCertificate(): void
}

interface OptionsProps extends OptionsEvents {
  participant: IExternalCourseParticipant
}

const Options: React.FC<OptionsProps> = ({
  participant,
  onDelete,
  onDeleteCertificate,
  onDownloadCertificate,
}) => {
  const { t } = useTranslation()
  const loading = false
  const [show, setShow] = useState(false)
  const { can, access } = useAccess()

  const handleDropdownClick = (showDropdown: boolean) => {
    setShow(showDropdown)
  }

  const canDelete = can('manageExternalCourses')
  const canDownloadCertificate = access.canDownloadReportWithViewAccess()

  const certificate = participant?.certificate

  const hasVisibleOptions = canDelete || canDownloadCertificate

  if (!hasVisibleOptions) {
    return null
  }

  return (
    <>
      <DropdownButton
        show={show}
        id="dropdown-menu-align-right"
        className={styles.actionSelect}
        alignRight
        title={<DropdownLoader loading={loading} />}
        onClick={() => handleDropdownClick(!show)}
        onToggle={() => handleDropdownClick(!show)}
      >
        {canDownloadCertificate && (
          <>
            <a
              className={classNames(!certificate && styles.disabled)}
              onClick={() => {
                certificate && onDeleteCertificate()
              }}
            >
              {t(joinKeys(prefixTranslation, 'deleteCertificate'))}
            </a>
            <a
              className={classNames(!certificate && styles.disabled)}
              onClick={() => {
                certificate && onDownloadCertificate()
              }}
            >
              {t(joinKeys(prefixTranslation, 'downloadCertificate'))}
            </a>
          </>
        )}
        {canDelete && (
          <a onClick={() => onDelete()}>
            {t(joinKeys(prefixTranslation, 'delete'))}
          </a>
        )}
      </DropdownButton>
    </>
  )
}

export default Options
